import formatCurrency from "../../../../../common/helpers/formatCurrency";
import i18n from "../../../../../i18n";
import { AssignmentSupplementPriceOverridesOverviewItem } from "../../../../talents/talentAPI";

export interface AssignmentSupplementPriceOverridesRowData {
  code: string;
  count: number;
  currentValue: string | null;
  nextDate: string | null;
  nextValue: string | null;
  unit: string | null;
  valueOrStatusText: string;
}

export const mapAssignmentSupplementPriceOverridesRows = (
  items: AssignmentSupplementPriceOverridesOverviewItem[],
): AssignmentSupplementPriceOverridesRowData[] =>
  items.map((item) => ({
    ...item,
    valueOrStatusText: getValueOrStatusText(item),
  }));

const formatPercentage = (value: string): string =>
  new Intl.NumberFormat("fi", {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(value));

const getValueOrStatusText = (
  item: AssignmentSupplementPriceOverridesOverviewItem,
) => {
  if (item.count > 1) {
    return i18n.t("tesPricingOverride:multipleValues");
  }

  if (!item.currentValue && item.nextDate) {
    return i18n.t("tesPricingOverride:notYetActive");
  }

  if (!item.currentValue) return "";

  return item.unit === "SALARY_MULTIPLIER"
    ? formatPercentage(item.currentValue)
    : formatCurrency(item.currentValue);
};
